import { render, staticRenderFns } from "./ProductPurchaseCreate.vue?vue&type=template&id=0bfe8f02&"
import script from "./ProductPurchaseCreate.vue?vue&type=script&lang=js&"
export * from "./ProductPurchaseCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports